module.exports = "<div class=\"tmb-page landing\">\r\n  <div class=\"simple-page landing-page\">\r\n    <div class=\"page-card\">\r\n      <img src=\"/assets/images/tmb_new.jpg\" alt=\"tropical medical bureau\" class=\"landing-logo\">\r\n      <p class=\"button-row center-row\">\r\n        <a md-raised-button color=\"primary\" (click)=\"login()\">Sign in</a>\r\n      </p>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"site-footer\">\r\n  <p>{{footer}}</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/landing/landing.component.html
// module id = ../../../../../src/app/pages/landing/landing.component.html
// module chunks = main